import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { SessionService } from '@core/services/session.service';
import { Platform } from '@ionic/angular';
import BackgroundGeolocation from 'cordova-background-geolocation-lt';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root',
})
export class GpsBackgroundService {
  private _isStarting: boolean = false;
  constructor(
    private _api: ApiService,
    private _platform: Platform,
    private _storage: StorageService,
    private _session: SessionService,
  ) {
  }
  init(): Promise<void> {
    console.log('iniciando gps background');
    return new Promise<void>(async (resolve, reject) => {
      const gps = await this._storage.get('gps');
      try {
        const state = await BackgroundGeolocation;
        await state.ready({
          locationAuthorizationRequest: 'Always',
          backgroundPermissionRationale: {
            title: 'Pemitir acceso a la localización del dispositivo en segundo plano?',
            message: 'Para poder usar la función del gps en segundo plano, por favor active el permiso "Permitir siempre"',
            positiveAction: 'Cambiar a Permitir siempre',
            negativeAction: 'Cancelar',
          },
        });
        console.log('[GPS] iniciated', state);
      } catch (e) {
        return reject(e);
      }
      const phone: string = await this._storage.get('phone');
      if (!phone) {
        return resolve();
      }
      if (gps && gps == 'true') {
        console.log('[GPS] activated previously');
        await this.stop();
        await this.start();
      }
      resolve();
    });
  }
  start(): Promise<void> {
    BackgroundGeolocation.onHttp(r => console.log('[GPS] http', r));
    return new Promise<void>(async resolve => {
      console.log('[GPS] starting..');
      if (this._isStarting) {
        return;
      }
      this._isStarting = true;
      await this.stop();
      const endPoint: string = `${environment.apiUrl}/gps/add`;
      const configPlatform = await this.getConfigPlatform(endPoint);
      await BackgroundGeolocation.setConfig(configPlatform);
      await BackgroundGeolocation.start();
      await BackgroundGeolocation.changePace(true);
      await this._storage.set('gps', 'true');
      this._isStarting = false;
      resolve();
    });
  }
  stop(): Promise<void> {
    return new Promise<void>(async resolve => {
      console.log('[GPS] stoping..');
      try {
        const stopSchedule = await BackgroundGeolocation.stopSchedule();
        console.log('[GPS] stopSchedule', stopSchedule);
        const stop = await BackgroundGeolocation.stop();
        console.log('[GPS] stop', stop);
      } catch (e) {
        console.log('[GPS] stop catch', e);
      }
      await this._storage.set('gps', 'false');
      resolve();
    });
  }
  private getConfigPlatform(endPoint: string): Promise<any> {
    return new Promise<any>(async resolve => {
      const bindedUnit = await lastValueFrom(this._api.get('/vinculate/status', true));
      const session = this._session.getSession();
      if (this._platform.is('android')) {
        return resolve({
          debug: false,
          httpTimeout: 300000,
          autoSync: true,
          desiredAccuracy: BackgroundGeolocation.DESIRED_ACCURACY_HIGH,
          distanceFilter: 0,
          foregroundService: true,
          enableHeadless: true,
          stopOnStationary: false,
          stopAfterElapsedMinutes: 0,
          allowIdenticalLocations: true,
          disableStopDetection: true,
          disableMotionActivityUpdates: true,
          stopTimeout: 24 * 60,
          // fastestLocationUpdateInterval: 1000,
          maxDaysToPersist: 5,
          locationUpdateInterval: 5000,
          logLevel: BackgroundGeolocation.LOG_LEVEL_VERBOSE,
          notification: { title: 'Assistant', text: 'GPS segundo plano activo' },
          reset: true,
          startOnBoot: true,
          stopOnTerminate: false,
          url: endPoint,
          extras: {
            phone: bindedUnit.unit.uid,
            session: { platformAccount: { name: session?.platformAccount?.name }, driver: { name: session?.driver?.name, phone: session?.driver?.phone } },
          },
          batchSync: true,
          disableElasticity: true,
          autoSyncThreshold: 10,
        });
      } else {
        return resolve({
          debug: false,
          httpTimeout: 300000,
          autoSync: true,
          desiredAccuracy: BackgroundGeolocation.DESIRED_ACCURACY_HIGH,
          distanceFilter: 0,
          stopOnStationary: false,
          stopAfterElapsedMinutes: 0,
          allowIdenticalLocations: true,
          disableStopDetection: true,
          disableMotionActivityUpdates: true,
          stopTimeout: 24 * 60,
          maxDaysToPersist: 5,
          locationUpdateInterval: 5000,
          logLevel: BackgroundGeolocation.LOG_LEVEL_VERBOSE,
          reset: true,
          startOnBoot: true,
          stopOnTerminate: false,
          heartbeatInterval: 60,
          url: endPoint,
          extras: {
            phone: bindedUnit.unit.uid,
            session: { platformAccount: { name: session?.platformAccount?.name }, driver: { name: session?.driver?.name, phone: session?.driver?.phone } },
          },
          batchSync: true,
          disableElasticity: true,
          autoSyncThreshold: 10,
          preventSuspend: true,
          stationaryRadius: 1,
        });
      }
    });
  }
}
